import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchUsersData =
  (token, search, page, sort, order) => async (dispatch) => {
    dispatch({ type: "FETCH_USERS_REQUEST" });

    let reqQuery = `?page=${page}&search=${search}`;
    if (sort) {
      reqQuery += `&sort=${sort}&order=${order}`;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getAllUsers${reqQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: "FETCH_USERS_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "FETCH_USERS_FAILURE", payload: error.message });
    }
  };
